module.exports = __webpack_public_path__ + "static/media/sr-splash800w.9078f45f.png";